import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "../APIClient";

export interface UserEventHistoryItem {
  eventId: number;
  eventDate: string;
  restaurantName: string | null;
  afterPartyName: string | null;
  restaurantScore: number | null;
  afterLocationScore: number | null;
  paymentStatus: string | null;
  attendanceStatus: string | null;
}

interface GetUserEventHistoryResponse {
  history: UserEventHistoryItem[];
}

export const useGetUserEventHistory = (userId: string, enabled: boolean) => {
  return useQuery({
    queryKey: ["user-event-history", userId],
    queryFn: async (): Promise<GetUserEventHistoryResponse> => {
      const response = await apiFetch(`api/admin/users/${userId}/event-history`);
      if (!response.ok) {
        throw new Error("사용자 이벤트 기록을 불러오지 못했습니다.");
      }
      return response.json();
    },
    enabled,
  });
};
